module.exports = __webpack_public_path__ + "img/xm03-2e4d72.png";